import { useEffect } from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import Dashboard from "../src/dashboard/Dashboard";
import LoginPage from "./Auth/Login";
import Registration from "./Auth/Registration";
import ProtectedRoute from "./Auth/Authentication/ProtectedRoute";
import PublicRoute from "./Auth/Authentication/PublicRoute";
import { startTokenWatcher, isAuthenticated } from './Services/tokenHelper';

function App() {
  useEffect(() => {
    if (isAuthenticated()) {
      startTokenWatcher();
    } else {
      localStorage.clear();
    }
  }, []);

  return (
    <Routes>
      {/* 🔓 Public Routes */}
      <Route
        path="/"
        element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        }
      />
      <Route
        path="/register"
        element={
          <PublicRoute>
            <Registration />
          </PublicRoute>
        }
      />

      {/* 🔒 Protected Routes - Direct Dashboard without division page */}
      <Route
        path="/dashboard/*"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default App;